export default __webpack_public_path__ + "static/media/Rewards_Promo(1).a2606026.jpg";